<template>
  <div>
    <LessonHeader v-if="!introClose" class="lessonOnTop" :outerData="lesson ? lesson.name : ''"></LessonHeader>
    <!-- <div class="loader" v-if="!lesson">
      איך אומרים לטעון...
      <br />to load -->
    <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
    <!-- <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div> -->
    <transition name="fade">
      <div v-if="!lesson"
        style="position:absolute; width: 100%; height:100%; top:0; left:0; z-index:10000; background-color:white; transtition: 1s;">
        <div style="margin-left: auto; margin-right: auto; height:100%; width:100%; display: flex;align-items: center;">
          <img
            src="https://uploads-ssl.webflow.com/63377a4edcea6933891249a2/63377d0fd67f06ef48eef306_MORIEL%20ENGLISH%20LOGO.svg"
            style="animation: wiggle 1.5s infinite; width: 80%; margin: auto" />
        </div>
      </div>
    </transition>
    <OnBoardingModal v-if="intro" :text="intro_text" :audioSrc="intro_audio" :imgSrc="intro_image" :vidSrc="intro_video"
      type="lesson" :id="id" @clicked="clicked" />
    <div v-if="lesson && introClose">
      <Lesson v-if="!lesson.game" :data="lesson"></Lesson>
      <WordGame v-if="lesson.game &&
        (lesson.game.game_type === 'half' ||
          lesson.game.game_type === 'full')
        " :data="lesson" :type="lesson.game.game_type" />
      <GrammarGame v-if="lesson.game && lesson.game.game_type === 'grammar'" :data="lesson" />
      <EnglishSen v-if="lesson.game && lesson.game.game_type === 'sentence'" :data="lesson" />
    </div>
  </div>
</template>

<script>
import "./lesson-page.scss";
import LessonHeader from "./lesson-header.vue";
import Spacer from "../Shared/Spacer.vue";
import Lesson from "./lesson-page.vue";
import WordGame from "../Game-new/game-page.vue";
import GrammarGame from "../GrammarGame/game-page.vue";
import EnglishSen from "../EngGame/allEng.vue";
import { userService } from "../../services/userService";
import OnBoardingModal from "../onBoardingModal/OnBoardingModal.vue";
import SlinkyVue from "../Shared/Slinky.vue";

export default {
  name: "lesson",
  props: [],
  data() {
    return {
      id: null,
      lesson: null,
      intro: false,
      intro_video: null,
      intro_audio: null,
      intro_image: null,
      intro_text: null,
      introClose: null
    };
  },
  created() {
    this.id = parseInt(this.$route.params.id);
    console.log(this.id);
    if (this.course) {
      this.makeLesson();
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    course() {
      return this.$store.getters.course;
    }
  },
  watch: {
    course() {
      this.makeLesson();
    }
  },
  methods: {
    clicked() {
      this.introClose = true;
    },
    getLesson(course, lesId) {
      let result = [];
      for (let chapter of course) {
        for (let sec of chapter.section) {
          for (let les of sec.lesson) {
            result.push({ ...les, chapter: chapter.id });
            if (les.id == lesId) {
              break;
            }
          }
        }
      }
      let res = result.find(lesson => lesson.id == lesId);
      this.$store.commit("setNextLesson", res);
      return res;
    },
    makeLesson() {
      if (this.id) {
        this.lesson = this.getLesson(this.course, this.id);
        // if (this.lesson.game && this.lesson.game.permission === "registered")
        if (this.lesson) {
          if (
            this.lesson.game &&
            (this.lesson.game.intro_image ||
              this.lesson.game.intro_video ||
              this.lesson.game.intro_audio ||
              this.lesson.game.intro_text)
          ) {
            this.intro_video = this.lesson.game.intro_video;
            this.intro_text = this.lesson.game.intro_text;
            this.intro_image = this.lesson.game.intro_image;
            this.intro_audio = this.lesson.game.intro_audio;
            this.intro = true;
            this.introClose = false;
          } else {
            this.introClose = true;
          }

          if (this.user) userService.startLesson(this.lesson.id);
          if (
            this.user &&
            this.lesson.game &&
            this.lesson.game.game_type === "grammar"
          )
            userService.startGame(this.lesson.game.id);
          if (
            this.user &&
            this.lesson.game &&
            this.lesson.game.game_type === "sentence"
          )
            userService.startGame(this.lesson.game.id);
        }
      }
    }
  },
  components: {
    LessonHeader,
    Spacer,
    Lesson,
    WordGame,
    GrammarGame,

    OnBoardingModal,
    EnglishSen,
    LessonHeader,
    SlinkyVue
  }
};
</script>

<style scoped>
.loader {
  text-align: center;
  margin: 30px;
}

img {
  width: 90vw;
}

iframe {
  height: 50vh;
}

.lessonOnTop {
  position: fixed;
  z-index: 999999;
  width: 100%;
}

@media (min-width: 780px) {
  .lessonOnTop {
    width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// lesson.vue?6c6ade58